import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ServiceProviderProfileForm, ServiceProviderProfileFormData } from '@/components/service-provider/ServiceProviderProfileForm';
import { useServiceProviderStore } from '@/stores/service-provider';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const ServiceProviderSetupPage: React.FC = () => {
  const navigate = useNavigate();
  const { isLoading, error, createProfile, clearError } = useServiceProviderStore();

  const handleSubmit = async (data: ServiceProviderProfileFormData) => {
    try {
      clearError();
      await createProfile(data);
      navigate('/service-provider/dashboard');
    } catch {
      // Error is set in store
    }
  };

  return (
    <div className="mx-auto max-w-2xl py-8 px-4">
      <Card className="mb-6">
        <CardHeader>
          <CardTitle className="text-2xl">Service Provider Profile Setup</CardTitle>
          <CardDescription>
            Set up your service provider profile to start configuring client projects for customers.
            Select your specializations and provide your business details.
          </CardDescription>
        </CardHeader>
      </Card>

      {error && (
        <div className="mb-4 rounded-md bg-red-50 p-4 text-sm text-red-700 dark:bg-red-900/20 dark:text-red-400">
          {error}
        </div>
      )}

      <ServiceProviderProfileForm
        onSubmit={handleSubmit}
        isLoading={isLoading}
        submitLabel="Create Service Provider Profile"
      />
    </div>
  );
};

export default ServiceProviderSetupPage;
